module.exports = __webpack_public_path__ + "static/uni_dc-e31a56c1a5dee957f375ab7138dc0fe6.png";